import Info from '@mui/icons-material/Info';
import { SvgIconProps } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

export const PortfolioInfoIcon = styled(({ className, ...rest }: SvgIconProps) => (
  <Info {...rest} className={clsx(className, 'info-icon')} />
))`
  &.info-icon {
    color: ${({ theme }) => theme.palette.darkened.steel};
    font-size: 1em;
    margin-left: ${({ theme }) => theme.spacing(0.5)};
    transform: translate(0, 0.2em);
  }
`;
